module.exports = __webpack_public_path__ + "static/media/card1.cdd05d88.png";